import APIService from "../../services/APIService";
import { getCookie } from "../../utils/CookieUtil";

const PendingVerificationAPI = {
  // Request phone number change using cookie-based authentication
  requestPhoneChange: async (newPhone) => {
    // Updated to use cookie-based authentication - backend needs this endpoint
    return APIService.post(`/api/v1/base/users/request-phone-change`, {
      newPhone,
    });
  },

  // Verify phone number change with code
  verifyPhoneChange: async (verificationCode) => {
    return APIService.post(`/api/v1/base/users/verify-phone-change`, {
      verificationCode,
    });
  },

  // Resend verification code for pending phone change
  resendPhoneChangeCode: async (newPhone) => {
    return APIService.post(`/api/v1/base/users/request-phone-change`, {
      newPhone,
    });
  },

  // Cancel pending phone number change
  cancelPhoneChange: async () => {
    return APIService.delete(`/api/v1/base/users/cancel-phone-change`);
  },

  // Get pending verification status using cookie-based authentication
  getPendingVerificationStatus: async () => {
    // Updated to use cookie-based authentication - backend needs this endpoint
    return APIService.get(`/api/v1/base/users/pending-verification-status`);
  },

  // Request email change using cookie-based authentication
  requestEmailChange: async (newEmail) => {
    // Updated to use cookie-based authentication - backend needs this endpoint
    return APIService.post(`/api/v1/base/users/request-email-change`, {
      newEmail,
    });
  },

  // Verify email change with verification token
  verifyEmailChange: async (verificationToken) => {
    return APIService.post(`/api/v1/base/users/verify-email-change`, {
      verificationToken,
    });
  },

  // Cancel pending email change
  cancelEmailChange: async () => {
    const userUuid = getCookie("user"); // Get selected user UUID
    if (!userUuid) {
      throw new Error("No user selected");
    }
    return APIService.delete(`/api/v1/base/users/cancel-email-change`);
  },
};

export default PendingVerificationAPI;
